import * as sagaEffects from 'redux-saga/effects';
import { LOCATION_CHANGE } from 'connected-react-router';
import { matchPath } from 'react-router';

import { get as _get } from 'lodash';

import config from 'config/index';

import { setMap } from '../actions';

const { takeEvery, put } = sagaEffects;

function* handler({ payload }) {
    const match = matchPath(payload.location.pathname, {
        path: config.routes.pinsDetail,
        exact: true,
    });
    const activePinId = _get(match, 'params.id', null);
    yield put(
        setMap({
            activePinId,
        }),
    );
}

export default function* () {
    yield takeEvery(LOCATION_CHANGE, handler);
}
